// dependencies
import { fromJS } from "immutable";

const UIState = fromJS({
	currentPage: 0,
	workflowTodos: [],
	workflowName: "",
	managerFallbackUser: "",
	startDate: null,
	documentPicker: null,
	lastFetchedWorkflowTemplate: null,
	inputs: {
		subject: {},
		workflowTemplate: "",
	},
	columns: [],
	columnWidths: { _isChecked: 50 },
});

export default UIState;
